import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid'
import MyProfileKeywordsRpaStyled from './styled'
import { Box, Tooltip } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { AlarmClock, AlertCircle, Archive, CheckCircle2, KeyRound, Pause, PencilLine, Power, PowerOff } from 'lucide-react'
import { MTText, CustomAlert, RegularButton, SearchInput, ToggleTabs, ActionsCell, ActionsGroup } from '../../atoms'
import { tokens } from '../../../assets/tokens'
import MaterialTable from 'material-table';
import ModalNewIntegration from '../../molecules/modal-new-integration';
import _ from 'lodash';
import ModalDisableIntegration from '../../molecules/modal-disable-integration';
import { useRpaIntegrations } from '../../../api/queries/useRpaIntegration';
import { INTEGRATIONS_RPA, ROLES } from '../../../config/constants'
import moment from 'moment';
import { AuthUtils } from '../../../redux/auth'

const MyProfileKeywordsRpa = ({ i18n, classes, self_data }) => {

    const isAdminUser = AuthUtils.hasRole(ROLES.ROLE_ATS_ADMIN_talent_acquisition) || AuthUtils.hasRole(ROLES.ROLE_ATS_ADMIN_ROOT);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalDisableOpen, setIsModalDisableOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [editingIntegration, setEditingIntegration] = useState(null);
    const [searchTerm, setSearchTerm] = useState({ term: '' });
    const [providerFilter, setProviderFilter] = useState('');
    const [isDisable, setIsDisable] = useState(false);
    const [isEnable, setIsEnable] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [showActiveIntegrations, setShowActiveIntegrations] = useState(true);
    const [alert, setAlert] = useState({ message: '', severity: '' })

    useEffect(() => {
        if (alert.message) {
            setShowAlert(true);
            const timer = setTimeout(() => {
                setShowAlert(false);
                setAlert({ message: '', severity: '' });
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [alert]);

    const options = [
        { id: INTEGRATIONS_RPA.INFOJOBS_PROVIDER.default, name: i18n.keywords_rpa.sourceInfojobs },
        { id: INTEGRATIONS_RPA.EPRESELEC_PROVIDER.default, name: i18n.keywords_rpa.sourceEpreselec },
        { id: INTEGRATIONS_RPA.COMPUTRABAJO_PROVIDER.default, name: i18n.keywords_rpa.sourceComputrabajo },
        { id: INTEGRATIONS_RPA.PANDAPE_PROVIDER.default, name: i18n.keywords_rpa.sourcePandape },
        { id: INTEGRATIONS_RPA.TURIJOBS_PROVIDER.default, name: i18n.keywords_rpa.sourceTurijobs },
        { id: INTEGRATIONS_RPA.INDEED_PROVIDER.default, name: i18n.keywords_rpa.sourceIndeed },
        { id: INTEGRATIONS_RPA.HELLOWORK_PROVIDER.default, name: i18n.keywords_rpa.sourceHellowork },
        { id: INTEGRATIONS_RPA.BIZNEO_PROVIDER.default, name: i18n.keywords_rpa.sourceBizneo },
        { id: INTEGRATIONS_RPA.JOBTODAY_PROVIDER.default, name: i18n.keywords_rpa.sourceJobtoday },
        { id: INTEGRATIONS_RPA.WORKABLE_PROVIDER.default, name: i18n.keywords_rpa.sourceWorkable },
        { id: INTEGRATIONS_RPA.TEAMTAILOR_PROVIDER.default, name: i18n.keywords_rpa.sourceTeamtailor },
        { id: INTEGRATIONS_RPA.TALENTCLUE_PROVIDER.default, name: i18n.keywords_rpa.sourceTalentclue },
    ];

    const optionsPriority = [
        { id: INTEGRATIONS_RPA.INFOJOBS_PROVIDER.priority, name: i18n.keywords_rpa.sourceInfojobsPriority },
        { id: INTEGRATIONS_RPA.EPRESELEC_PROVIDER.priority, name: i18n.keywords_rpa.sourceEpreselecPriority },
        { id: INTEGRATIONS_RPA.COMPUTRABAJO_PROVIDER.priority, name: i18n.keywords_rpa.sourceComputrabajoPriority },
        { id: INTEGRATIONS_RPA.PANDAPE_PROVIDER.priority, name: i18n.keywords_rpa.sourcePandapePriority },
        { id: INTEGRATIONS_RPA.TURIJOBS_PROVIDER.priority, name: i18n.keywords_rpa.sourceTurijobsPriority },
        { id: INTEGRATIONS_RPA.INDEED_PROVIDER.priority, name: i18n.keywords_rpa.sourceIndeed },
        { id: INTEGRATIONS_RPA.HELLOWORK_PROVIDER.priority, name: i18n.keywords_rpa.sourceHellowork },
        { id: INTEGRATIONS_RPA.BIZNEO_PROVIDER.priority, name: i18n.keywords_rpa.sourceBizneo },
        { id: INTEGRATIONS_RPA.JOBTODAY_PROVIDER.priority, name: i18n.keywords_rpa.sourceJobtoday },
        { id: INTEGRATIONS_RPA.WORKABLE_PROVIDER.priority, name: i18n.keywords_rpa.sourceWorkable },
        { id: INTEGRATIONS_RPA.TEAMTAILOR_PROVIDER.priority, name: i18n.keywords_rpa.sourceTeamtailor },
        { id: INTEGRATIONS_RPA.TALENTCLUE_PROVIDER.priority, name: i18n.keywords_rpa.sourceTalentclue },
    ]

    const { data: rpaData, refetch } = useRpaIntegrations(self_data.client_id);

    const handleDataUpdate = async () => {
        try {
            await refetch();
            setIsModalOpen(false);
            setIsModalDisableOpen(false);

            if (isEnable || isDisable) {
                setAlert({
                    message: isEnable
                        ? i18n.keywords_rpa.integrationDisabledSuccessfully
                        : i18n.keywords_rpa.integrationEnabledSuccessfully,
                    severity: 'success',
                    section: isEnable ? 'inactive' : 'active',
                });

                setIsEnable(false);
                setIsDisable(false);
            }
        } catch (error) {
            console.error('error', error);
        }
    };

    const filterData = (searchTermValue, providerFiltered, isActive) => {
        if (!rpaData || rpaData.length === 0) {
            return [];
        }

        const isStaffEmail = self_data?.email.includes('@hrbotfactory') || self_data?.email.includes('@velorahr');
        const allOptions = [...options, ...optionsPriority];

        const nameFilteredData = rpaData.filter((rpa) => {
            const isUserActive = rpa.active === isActive;
            if (!isUserActive || (rpa.provider === 'demo' && !isStaffEmail)) {
                return false;
            }

            const userMatch = rpa.user?.toLowerCase().includes(searchTermValue.toLowerCase());
            const candidatureMatch = rpa?.position_name ? rpa.position_name.toLowerCase().includes(searchTermValue.toLowerCase()) : null;
            const providerMatch = rpa.provider?.toLowerCase().includes(searchTermValue.toLowerCase());

            return userMatch || candidatureMatch || providerMatch;
        });

        const providerFilteredData = providerFiltered
            ? nameFilteredData.filter((user) => {
                const selectedProvider = allOptions.find(option => String(option.id) === String(user.provider));
                const profileName = selectedProvider ? selectedProvider.name : user.provider;

                return profileName.toLowerCase() === providerFiltered.toLowerCase();
            })
            : nameFilteredData;

        return providerFilteredData;
    };

    const activeIntegrations = filterData(searchTerm.term, providerFilter, true);
    const inactiveIntegrations = filterData(searchTerm.term, providerFilter, false);

    const handleProviderFilter = (_, value) => {
        setProviderFilter(value ? value.id : '');
    };

    const handleSearchTerm = _.debounce((value) => {
        setSearchTerm({ term: value });
    }, 250);

    const handleEditIconClick = (row) => {
        if (row.active) {
            setEditingIntegration(row);
            setIsEdit(true);
            setIsModalOpen(true);
        }
    };

    const handleDisableAndEnableIconClick = (row) => {
        const currentStatus = row.active;
        setEditingIntegration(row);
        setIsEdit(false);
        setIsModalDisableOpen(true);
        setIsDisable(!currentStatus);
        setIsEnable(currentStatus);
    };

    const tableOptions = {
        emptyRowsWhenPaging: false,
        loadingType: 'linear',
        cellStyle: { textAlign: 'center' },
        pageSize: 10,
        pageSizeOptions: [10, 25, 50, 100],
        toolbar: false,
        draggable: false,
        selection: false,
    }

    const getIconByIntegrationStatus = (status) => {
        const icons = {
            pending: <AlarmClock size={18} color={tokens.color.text.secondary} />,
            ok: <CheckCircle2 size={18} color={tokens.color.success.main} />,
            error_login: <KeyRound size={18} color={tokens.color.error.main} />,
            error_generic: <AlertCircle size={18} color={tokens.color.error.main} />,
        };

        return icons[status] || icons.pending;
    };

    const tableColumns = {
        position: {
            title: i18n.keywords_rpa.position,
            render: function PositionColumn(row) {
                return <MTText value={row?.position_name ?? '-'} style={{ fontWeight: '400' }} />;
            },
            field: 'position_name'
        },
        provider: {
            title: i18n.keywords_rpa.source,
            render: function SourceColumn(row) {
                let providerName;

                if (row.provider === INTEGRATIONS_RPA.INFOJOBS_PROVIDER.priority) {
                    providerName = i18n.keywords_rpa.sourceInfojobsPriority;
                }
                else if (row.provider === INTEGRATIONS_RPA.EPRESELEC_PROVIDER.priority) {
                    providerName = i18n.keywords_rpa.sourceEpreselecPriority;
                }
                else {
                    const selectedProvider = options.find(option => String(option.id) === String(row.provider));
                    providerName = selectedProvider ? selectedProvider.name : row.provider;
                }

                return <MTText value={providerName} style={{ fontWeight: '400' }} />;
            },
            field: 'provider'
        },
        user: {
            title: i18n.keywords_rpa.user,
            render: function UserColumn(row) {
                return <MTText value={row.user} style={{ fontWeight: '400' }} />;
            },
            field: 'user'
        },
        keyword: {
            title: i18n.keywords_rpa.keyword,
            render: function KeywordColumn(row) {
                return <MTText value={row.keyword} style={{ fontWeight: '400' }} />;
            },
            field: 'keyword'
        },
        connectionStatus: {
            title: i18n.keywords_rpa.connectionStatus,
            render: function ConnectionStatusColumn(row) {
                const title = row.active ? (i18n.keywords_rpa.connectionStatuses[row.status] || row.status || i18n.keywords_rpa.connectionStatuses.pending) : i18n.keywords_rpa.inactiveIntegration;
                const icon = row.active ? getIconByIntegrationStatus(row.status) : <Pause size={18} color={tokens.color.text.secondary} />;
                return <Tooltip title={title}>
                    <div style={{ display: 'inline-flex', cursor: 'help' }}>{icon}</div>
                </Tooltip>;
            },
            field: 'status',
            hidden: false,
        },
        lastExecution: {
            title: i18n.keywords_rpa.lastExecution,
            render: function ConnectionStatusColumn(row) {
                const date = row.last_execution_date ? moment(row.last_execution_date).format('DD/MM/YYYY HH:mm') : '-';
                return <MTText value={date} style={{ fontWeight: '400' }} />;
            },
            field: 'status',
            hidden: false,
            customSort: (a, b) => {
                return (new Date(a.last_execution_date || null).getTime()) - (new Date(b.last_execution_date || null).getTime());
            }
        },
        // Una sola columna con las dos acciones; editar se queda visible pero deshabilitado en las
        // integraciones inactivas, como antes
        actions: {
            title: i18n.user_management.actions,
            hidden: !isAdminUser,
            sorting: false,
            headerStyle: { width: 96, whiteSpace: 'nowrap' },
            cellStyle: { width: 96 },
            render: function ActionsColumn(row) {
                if (row.flow_type === 'evaluation_profile') {
                    return <></>
                }

                const isIntegrationActive = row.active;
                return (
                    <ActionsGroup>
                        <ActionsCell
                            icon={<PencilLine size={18} color={isIntegrationActive ? tokens.color.text.secondary : tokens.color.text.disabled} />}
                            tooltip={i18n.keywords_rpa.modalTitleEditIntegration}
                            disabled={!isIntegrationActive}
                            onClick={() => handleEditIconClick(row)}
                        />
                        <ActionsCell
                            icon={isIntegrationActive
                                ? <PowerOff size={18} color={tokens.color.text.secondary} />
                                : <Power size={18} color={tokens.color.text.secondary} />}
                            tooltip={isIntegrationActive ? i18n.keywords_rpa.disableIntegration : i18n.keywords_rpa.enableIntegration}
                            onClick={() => handleDisableAndEnableIconClick(row)}
                        />
                    </ActionsGroup>
                );
            },
            field: 'actions',
        }
    };

    const columnsArray = Object.values(tableColumns);

    columnsArray.forEach(column => {
        if (column.render) {
            column.render.displayName = `${column.field}_render`;
        }
    });

    const handleNewIntegration = () => {
        setIsEdit(false);
        setIsModalOpen(true);
    };

    // Sin el Paper por defecto de material-table: las tablas van sobre el fondo de la página,
    // como en la bandeja de candidatos
    const tableComponents = { Container: props => <div {...props} /> }

    return (
        <div className={classes.root}>
            <MyProfileKeywordsRpaStyled>
                <div className="containerHeader">
                    <Grid container spacing={4}>
                        <Grid item className="sectionSecond" xs={12} sm={12}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: "flex-start", gridGap: '15px', maxWidth: "700px", }}>
                                <h2>{i18n.keywords_rpa.titleSection}</h2>
                                <h5>{i18n.keywords_rpa.descriptionSection}</h5>
                            </Box>
                            {isAdminUser && <Box sx={{ display: 'flex', alignItems: "flex-start", placeSelf: 'flex-start' }}>
                                <RegularButton className="button-custom" title={i18n.keywords_rpa.newIntegration}
                                               onClick={handleNewIntegration}
                                />
                            </Box>}
                        </Grid>

                        <Grid item xs={12} sm={12} >
                            <Grid item className="headerTable integrations-header">
                                <div className="integrations-filters">
                                    <SearchInput
                                        placeholder={i18n.evaluativeTests.placeholderInputTerm}
                                        onChange={value => handleSearchTerm(value)}
                                    />
                                    <Autocomplete
                                        className='autocomplete-custom'
                                        options={options}
                                        getOptionLabel={(option) => option.name}
                                        onChange={handleProviderFilter}
                                        renderInput={(params) => (
                                            <TextField {...params} placeholder={i18n.keywords_rpa.placeholderFilter} variant="outlined" />
                                        )}
                                    />
                                </div>
                                <div className="integrations-actions">
                                    {showActiveIntegrations
                                        ? showAlert && !isDisable && alert.section === 'inactive' && <CustomAlert severity={alert.severity} message={alert.message} />
                                        : showAlert && !isEnable && alert.section === 'active' && <CustomAlert severity={alert.severity} message={alert.message} />}
                                    <ToggleTabs
                                        value={showActiveIntegrations}
                                        onChange={setShowActiveIntegrations}
                                        tabs={[
                                            { label: i18n.keywords_rpa.activeIntegrations, value: true, icon: CheckCircle2 },
                                            { label: i18n.keywords_rpa.inactiveIntegrations, value: false, icon: Archive }
                                        ]}
                                    />
                                </div>
                            </Grid>
                            <MaterialTable
                                key={showActiveIntegrations ? 'active-integrations' : 'inactive-integrations'}
                                data={showActiveIntegrations ? activeIntegrations : inactiveIntegrations}
                                columns={columnsArray}
                                options={tableOptions}
                                components={tableComponents}
                            />
                        </Grid>

                        <ModalNewIntegration
                            open={isModalOpen}
                            handleClose={() => setIsModalOpen(false)}
                            i18n={i18n}
                            isEdit={isEdit}
                            editingIntegration={editingIntegration}
                            self_data={self_data}
                            onDataUpdate={handleDataUpdate}
                        />

                        <ModalDisableIntegration
                            open={isModalDisableOpen}
                            handleClose={() => setIsModalDisableOpen(false)}
                            i18n={i18n}
                            self_data={self_data}
                            onDataUpdate={handleDataUpdate}
                            integrationData={editingIntegration}
                        />
                    </Grid>
                </div>
            </MyProfileKeywordsRpaStyled>
        </div>
    );
};

export default MyProfileKeywordsRpa;
